var ArtifactSource;
(function (ArtifactSource) {
    ArtifactSource["LOCAL"] = "local";
    ArtifactSource["REMOTE"] = "remote";
})(ArtifactSource || (ArtifactSource = {}));
export const EncounterStatus_Initial = 'initial';
export const EncounterStatus_Viewed = 'viewed';
export const EncounterStatus_Managed = 'managed';
export const EncounterStatus_Documented = 'documented';
export const EncounterStatuses = [EncounterStatus_Initial, EncounterStatus_Viewed, EncounterStatus_Managed, EncounterStatus_Documented];
//# sourceMappingURL=types.js.map